import { BffApiClient } from '@/common/services/api/bffClient';
import { PageMetiersApiResponse, RelatedPagesApiResponse } from '../types/pageMetiersTypes';
import { pagesMetiersEndpoints } from '../endpoints/pagesMetiersEndpoints';

export class PagesService {
  private static api = BffApiClient.getInstance();

  static async getPage(pageId: number): Promise<PageMetiersApiResponse> {
    const response = await this.api.get<PageMetiersApiResponse>(
      pagesMetiersEndpoints.getPage(pageId)
    );
    return response.data as PageMetiersApiResponse;
  }

  static async getRelatedPages(parentId: number): Promise<RelatedPagesApiResponse> {
    const response = await this.api.get<RelatedPagesApiResponse>(
      pagesMetiersEndpoints.getRelatedPages(parentId)
    );
    return response.data as RelatedPagesApiResponse;
  }
}
